export { LanguageHighlighter } from './LanguageHighlighter';
